import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Grid,
  Stepper,
  Step,
  StepLabel,
  Stack,
  Typography,
  StepConnector,
} from "@mui/material";

import "./../formStyle.scss";
import { CORPORATE_FORM_STEPS } from "../../config/constant";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  setActiveStep,
  setApplicantActiveStep,
  setApplicantTotal,
  setShowMobileStepper,
  setShowSaveAndPreview,
} from "./new-booking-form.slice";
import OtherDetailStepIcon from "../../assets/component-icon/OtherDetailStepIcon";
import ReviewDetailStepIcon from "../../assets/component-icon/ReviewDetailStepIcon";
import PaymentDetailStepIcon from "../../assets/component-icon/PaymentDetailStepIcon";
import TermsConditionStepIcon from "../../assets/component-icon/TermsConditionStepIcon";
import ApplicantDetailStepIcon from "../../assets/component-icon/ApplicantDetailStepIcon";
import DocumentReviewStepIcon from "../../assets/component-icon/DocumentReviewStepIcon";
import TermsAndCondition from "./components/terms-and-condition/TermsAndCondition";
import Header from "../../layout/header/Header";
import SnackbarAlert from "../../shared-components/snackbar-alert/SnackbarAlert";

import Arrowgreen from "../../assets/icons/line2.svg";
import AuthorizedSignatoryDetails from "./components/AuthorizedSignatoryDetails";
import CompanyDocument from "./components/CompanyDocument";
import CompanyDetails from "./components/CompanyDetails";
import ReviewDetails from "./components/ReviewDetails/ReviewDetails";
import CorporatePaymentOption from "./components/CorporatePaymentOptions";
import { useTranslation } from "react-i18next";
import StepperIconRoot from "../../shared-components/stepper/StepperIconRoot";
const CorporateBookingForm = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    isCorporateFlow,
    entity,
    activeStep,
    applicantTotal,
    applicantData,
    showMobileStepper,
    applicantActiveStep,
    checkFirstStepCompleted,
    applicantActiveStep1,
    applicantActiveStep2,
  } = useSelector((state) => state?.newBookingForm);

  const [steps, setSteps] = useState([]);
  const [stepsArray, setStepsArray] = useState([]);
  const [lastStep, setLastStep] = useState(0);
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    setLastStep(applicantData?.lastStep ?? 0);
    const signatoryCount = isCorporateFlow
      ? Math.max(applicantTotal || 0, 1) // Corporate Min 1 Applicant
      : Math.max(applicantTotal || 0, 2); // Partnership Min 2 Applicants

    dispatch(setApplicantTotal(signatoryCount));

    let corporateSteps = CORPORATE_FORM_STEPS(signatoryCount, entity, t);

    corporateSteps = corporateSteps.map((step, index) => ({
      ...step,
      label: `Step ${index + 1}`,
    }));

    let stepsArray = corporateSteps.map((step, index) => {
      if (step.description.includes(t("stepper.entityDetails", { entity }))) {
        return <CompanyDetails key={index} />;
      } else if (
        step.description.includes(t("stepper.entityDocuments", { entity }))
      ) {
        return <CompanyDocument key={index} />;
      } else if (step.description.includes(t("stepper.authorizedSignatory"))) {
        const signatoryNumber = parseInt(step?.description?.match(/\d+/)?.[0] || 1);
        return (
          <AuthorizedSignatoryDetails
            key={index}
            applicantNo={signatoryNumber}
          />
        );
      } else if (step.description.includes(t("stepper.reviewDetails"))) {
        return <ReviewDetails key={index} />;
      } else if (step.description.includes(t("stepper.paymentDetails"))) {
        return <CorporatePaymentOption key={index} />;
      } else if (step.description.includes(t("stepper.termsAndConditions"))) {
        return <TermsAndCondition key={index} />;
      }
    });


    setSteps(corporateSteps);
    setStepsArray(stepsArray);

    return () => {};
  }, [
    applicantTotal,
    activeStep,
    applicantData,
    pathname,
    entity,
    dispatch,
    isCorporateFlow,
    t,
  ]);

  // useEffect(() => {
  //   const debounceTimeout = setTimeout(() => {
  //     if (oppId?.length > 0) {
  //       dispatch(getOppprtunityDetails(`/${oppId}`))
  //         .unwrap()
  //         .then((res) => {
  //           if (res?.data !== null) {
  //             getTermsAndCondition(res?.data);
  //           }
  //         })
  //         .catch((error) => {});

  //       dispatch(getMasterDataList());
  //       dispatch(getApplicantDetails(`/${oppId}`))
  //         .unwrap()
  //         .then((res) => {
  //           if (res?.signedPdf === null) {
  //             if (
  //               res?.leegalityData?.isSignLater === true ||
  //               applicantData?.bookingFormStatus ===
  //                 BOOKING_FORM_STATUS?.PARTIALLY_SIGNED ||
  //               applicantData?.bookingFormStatus ===
  //                 BOOKING_FORM_STATUS?.NOT_SIGNED ||
  //               applicantData?.bookingFormStatus ===
  //                 BOOKING_FORM_STATUS?.SIGNED_OFFLINE
  //             ) {
  //               history.push(`/customer-preview/${oppId}`);
  //             } else {
  //               dispatch(setApplicantTotal(res?.noOfApplicants));
  //               if (!isFromPreview?.value) {
  //                 dispatch(setActiveStep(res?.lastStep || 0));
  //               } else {
  //                 dispatch(setActiveStep(isFromPreview?.index || 0));
  //                 dispatch(setIsFromPreview({ value: false, index: null }));
  //               }
  //             }
  //           }
  //           if (res?.signedPdf !== null) {
  //             dispatch(setActiveStep(0));
  //             history.push(`/thank-you/${oppId}`);
  //           }
  //         })
  //         .catch((error) => {
  //           dispatch(setResetData());
  //           if (!error?.errors?.message?.includes("Booking with Opportunity")) {
  //             setSnackbarConfig({
  //               open: true,
  //               message: ERROR_MESSAGE,
  //               severity: "error",
  //             });
  //           }
  //         });
  //     }
  //   }, 300);

  //   return () => clearTimeout(debounceTimeout);
  // }, []);

  function ColorlibStepIcon(props) {
    const { active, className, icon } = props;
    const isStepCompleted =
      applicantData?.companyDetails &&
      checkFirstStepCompleted === false &&
      lastStep >= icon;
    const icons = {};
    const isStepActiveAndCompleted = isStepCompleted && active;
    steps.forEach((step, index) => {
      if (step.description.includes(t("stepper.entityDetails", { entity }))) {
        icons[index] = (
          <OtherDetailStepIcon
            show={Boolean(active)}
            completed={isStepCompleted}
          />
        );
      } else if (
        step.description.includes(t("stepper.entityDocuments", { entity }))
      ) {
        icons[index] = (
          <DocumentReviewStepIcon
            show={Boolean(active)}
            completed={isStepCompleted}
          />
        );
      } else if (step.description.includes(t("stepper.authorizedSignatory"))) {
        icons[index] = (
          <ApplicantDetailStepIcon
            show={Boolean(active)}
            completed={isStepCompleted}
          />
        );
      } else if (step.description.includes(t("stepper.reviewDetails"))) {
        icons[index] = <ReviewDetailStepIcon completed={isStepCompleted} />;
      } else if (step.description.includes(t("stepper.paymentDetails"))) {
        icons[index] = (
          <PaymentDetailStepIcon
            show={Boolean(active)}
            completed={isStepCompleted}
          />
        );
      } else if (step.description.includes(t("stepper.termsAndConditions"))) {
        icons[index] = (
          <TermsConditionStepIcon
            show={Boolean(active)}
            completed={isStepCompleted}
          />
        );
      }
    });

    return (
      <StepperIconRoot
        ownerState={{
          active,
          isStepCompleted,
          variant: "default",
        }}
        className={className}
      >
        {/* {completed ? <CheckBoxIcon /> : active ? <EditIcon /> : null} */}
        {icons[props.icon]}
        <div className="step-label">
          {isStepActiveAndCompleted && (
            <img
              src={Arrowgreen}
              alt="Completed Step"
              className="arrowTriangleLeft"
              // style={{
              //   width: "7px",
              //   marginLeft: "6px",
              //   position: "absolute",
              //   right: showMobileStepper ? "63%" : "70%",
              //   top: "5px",
              // }}
            />
          )}
        </div>
      </StepperIconRoot>
    );
  }

  const getForm = (step) => {
    return stepsArray[step];
  };

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };
  const handleStep = (step) => () => {
    dispatch(setShowMobileStepper(false));
    if (lastStep >= step) {
      dispatch(setShowSaveAndPreview(false))
      //dispatch(setEditPreviewApplicant(false));

      dispatch(setActiveStep(step || 0));
      if (
        step + 1 <= applicantData?.noOfApplicants &&
        step + 1 !== 3 &&
        step + 1 !== 4
      ) {
        if (step + 1 === 1) {
          dispatch(setApplicantActiveStep(applicantActiveStep1));
        }
        if (step + 1 === 2) {
          dispatch(setApplicantActiveStep(applicantActiveStep2));
        }
      }
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [applicantActiveStep, activeStep]);

  useEffect(() => {
    if (
      activeStep + 1 <= applicantData?.noOfApplicants &&
      activeStep + 1 !== 3 &&
      activeStep + 1 !== 4
    ) {
      if (activeStep + 1 === 1) {
        dispatch(setApplicantActiveStep(applicantActiveStep1));
      }
      if (activeStep + 1 === 2) {
        dispatch(setApplicantActiveStep(applicantActiveStep2));
      }
    }
  }, [activeStep]);

  //   useEffect(() => {
  //  dispatch(setActiveStep(4))
  // }, [activeStep]);

  return (
    <>
      <Helmet>
        <title>{t("bookingForm.titlePuravankara")}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <>
               <Header 
          isMenuOpen={showMobileStepper}
          onToggleMenu={() => dispatch(setShowMobileStepper(!showMobileStepper))}
        />
        <Stack>
          <Grid
            container
            spacing={0}
            sx={{
              p: 0,
              paddingLeft: {
                xs: "16px",
                sm: "16px",
                md: "16px",
                lg: "7%",
              },
              paddingRight: {
                xs: "16px",
                sm: "16px",
                md: "16px",
                lg: "7%",
              },
              mb: {
                xs: 2,
                sm: 4,
                md: 5, // Desktop
              },
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                textAlign: {
                  xs: "center",
                  sm: "center",
                  md: "center",
                },
                pt: {
                  xs: "16px",
                  sm: "30px",
                  md: "36px",
                },
                pb: {
                  xs: "16px",
                  sm: "18px",
                  md: "20px",
                },
              }}
            >
              <Typography
                sx={{
                  color: "#1A407D",
                  fontSize: {
                    xs: "20px",
                    sm: "20px",
                    md: "24px",
                  },
                  fontWeight: "700",
                  lineHeight: {
                    xs: "28px",
                    sm: "32px",
                    md: "36px",
                  },
                  mb: {
                    xs: 0.5,
                    sm: 1,
                    md: 1,
                  },
                }}
              >
                {t("bookingForm.title")}
              </Typography>
              <Typography
                sx={{
                  color: "#1C252E",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "22px",
                }}
              >
                {t("bookingForm.helperText")}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <Box
                className={`mobileDrawer ${
                  showMobileStepper === true ? "OpenDrawer" : ""
                }`}
                sx={{
                  borderRadius: "8px",
                  border: "1px solid rgba(26, 64, 125, 0.30)",
                }}
              >
                <div className="mobileDrawerOverly"> </div>
                <div className="mobileDrawerBox">
                  <Stepper
                    activeStep={activeStep || 0}
                    orientation="vertical"
                    connector={
                      <StepConnector
                        sx={{
                          ml: "19px",
                        }}
                      />
                    }
                    sx={{
                      "& .MuiStepConnector-line": {
                        border: "0px",
                        borderLeft: "2px dotted #D6D6D6",
                        minHeight: "34px",
                        // borderColor: activeStep === 0 ? "#D6D6D6" : "#1A407D",
                        // borderLeftStyle: activeStep === 0 ? "dotted" : "solid",
                      },
                      "& .MuiStepLabel-label": {
                        color: activeStep === 0 ? "green" : "blue",
                      },
                      "& .MuiStepIcon-root": {
                        color: activeStep === 0 ? "orange" : "purple",
                      },
                    }}
                  >
                    {steps.map((step, index) => {
                      return (
                        <Step key={index}>
                          <StepLabel
                            StepIconComponent={(props) => (
                              <ColorlibStepIcon {...props} icon={index} />
                            )}
                            sx={{
                              p: 0,
                              cursor: "pointer",
                              position: "relative",
                            }}
                            onClick={handleStep(index)}
                          >
                            <Typography
                              sx={{
                                color: "#7A7A7A",
                                fontSize: "12px",
                                fontWeight: "400",
                                lineHeight: "18px",
                                mb: "3px",
                              }}
                            >
                              {step.label}
                            </Typography>
                            <Typography
                              sx={{
                                color: "#1C252E",
                                fontSize: "14px",
                                fontWeight: "600",
                                lineHeight: "22px",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: step.description,
                              }}
                            ></Typography>
                          </StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                </div>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={9}>
              <Box
                sx={{
                  borderRadius: "8px",
                  border: "1px solid rgba(26, 64, 125, 0.30)",
                  padding: {
                    xs: "16px",
                    sm: "16px",
                    lg: "26px 39px 26px 39px",
                  },
                  marginLeft: {
                    xs: "0",
                    sm: "0",
                    lg: "24px",
                  },
                }}
              >
                {getForm(activeStep)}
                {/* need to show referral details popup */}
                {/* <ReferralDetails /> */}

                {/* <ApplicantDetail applicantNo={1} /> */}

                {/* <UploadPopup
                heading="Upload your photo"
                totalImages={1}
              /> */}
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </>
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default CorporateBookingForm;
